import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine, getQueryString } from 'src/app/shared/utilities/route';
import { serializeToQueryString } from 'src/app/shared/utilities/serialize-to-query-string';
import { SubmittalJobMatchCalculation } from 'src/app/recruiting/candidates/submittal/models/submittal-job-match-calculation.model';
import { SubmittalJobQualifications } from 'src/app/recruiting/candidates/submittal/models/submittal-job-qualifications.model';

@Injectable({
    providedIn: 'root'
})
export class JobMatchingService {
    private readonly _coreApiPath: string;

    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _settings: Settings = inject(APP_CONFIG);

    constructor() {
        this._coreApiPath = combine(this._settings.coreAPIUrl, 'ayanova');
    }

    getQualifications(userId: number, jobIds: number[]): Observable<SubmittalJobQualifications> {
        const jobIdsObj = { jobIds };
        const getUri = `${this._coreApiPath}/job-matching/${userId}${serializeToQueryString(jobIdsObj)}`;
        return this._httpClient.get<SubmittalJobQualifications>(getUri);
    }

    getCalculations(userId: number, submittalId: number): Observable<SubmittalJobMatchCalculation[]> {
        const getUri = `${this._coreApiPath}/job-matching/calculations/${userId}/${submittalId}`;
        return this._httpClient.get<SubmittalJobMatchCalculation[]>(getUri);
    }

    getRecruiterCalculations(recruiterId: number): Observable<SubmittalJobMatchCalculation[]> {
        const getUri = `${this._coreApiPath}/job-matching/calculations/${recruiterId}`;
        return this._httpClient.get<SubmittalJobMatchCalculation[]>(getUri);
    }

    getExplanations(submittalId: number, userId: number, jobId: number): Observable<SubmittalJobQualifications> {
        const url = `${this._coreApiPath}/job-matching/explanations/${submittalId}/${userId}/${jobId}`;
        return this._httpClient.get<SubmittalJobQualifications>(url);
    }

    saveExplanations(explanations: SubmittalJobQualifications): Observable<void> {
        const url = `${this._coreApiPath}/job-matching/explanations`;
        return this._httpClient.post<void>(url, explanations);
    }

    saveJobMatchPercentages(submittalId: number, percentages: SubmittalJobMatchCalculation[]): Observable<number> {
        const baseUri = `${this._coreApiPath}/job-matching/calculations/${submittalId}`;
        return this._httpClient.post<number>(baseUri, percentages);
    }

    getAvailableJobsForQualifications(jobIds: number[]): Observable<number[]> {
        const jobIdsObj = { jobIds };
        const getUri = `${this._coreApiPath}/job-matching/valid-jobs${serializeToQueryString(jobIdsObj)}`;
        return this._httpClient.get<number[]>(getUri);
    }

    getCalculationsByJobIds(userId: number, args: any): Observable<SubmittalJobQualifications> {
        let getUri = `${this._coreApiPath}/job-matching/calculations/job-match/user/${userId}`;
        if (args.filter) {
            getUri += getQueryString(args.filter);
        }
        return this._httpClient.get<SubmittalJobQualifications>(getUri);
    }
}
